import { FsDir } from "./fsentry";
import { apiFetch, mkURL, throwIfFetchFailed, xhrPut } from "./http";
import { throwIf } from "./util";
import { s3SanitizeDir, s3SanitizePath } from "./fs-s3";

import type { BackBlazeConfig } from "./fs";
import { FS } from "./fs";
import type { HttpProgress } from "./http";
import type { Writable } from "svelte/store";

class FileSystemBackBlaze extends FS {
  constructor(config: BackBlazeConfig) {
    super(config);
  }

  get bbConfig(): BackBlazeConfig {
    return this.config as BackBlazeConfig;
  }

  /**
   * directory name
   * if true, don't use cached values
   * progress
   */
  async readDir(
    dirPath: string,
    force: boolean,
    progress: Writable<any>
  ): Promise<FsDir> {
    throwIf(dirPath == "", `empty dirName`);
    return this.loadDir(dirPath, force, progress, async () => {
      let entries = await bbGetFiles(this.bbConfig, dirPath);
      return FsDir.fromWire(dirPath, entries);
    });
  }

  async getPublicURL(path: string): Promise<string> {
    console.log(`bb.getPublicURL: path=${path}`);

    // TODO: maybe cache the links?
    let c = this.bbConfig;
    let url = mkURL(
      `/api/bb/getpublicurl`,
      "appKeyId",
      c.appKeyId,
      "appKey",
      c.appKey,
      "bucketName",
      c.bucketName,
      "path",
      path
    );

    let response = await apiFetch(url);
    throwIfFetchFailed(response);
    let js = await response.json();
    url = js.url;
    console.log("bb.getPublicURL: url:", url);
    return url;
  }

  async uploadFile(
    path: string,
    file: Blob,
    httpProgress: HttpProgress
  ): Promise<void> {
    console.log("bb.uploadFile: ${path}");
    path = s3SanitizePath(path);
    let c = this.bbConfig;
    let url = mkURL(
      `/api/bb/upload`,
      "appKeyId",
      c.appKeyId,
      "appKey",
      c.appKey,
      "bucketId",
      c.bucketId,
      "path",
      path
    );
    let rsp = await xhrPut(url, file, httpProgress);
    console.log(rsp.response);
  }

  async rename(path: string, newPath: string): Promise<void> {
    let found = this.findFirstEntryOfType(path, false);
    let sourceFileId = found.dir.entryId(found.entry);
    console.log(
      `bb.rename: path=${path} sourceFileId: ${sourceFileId}, newPath=${newPath}`
    );
    let c = this.bbConfig;
    let url = mkURL(
      `/api/bb/rename`,
      "appKeyId",
      c.appKeyId,
      "appKey",
      c.appKey,
      "sourceFileId",
      sourceFileId,
      "newPath",
      newPath
    );
    let response = await apiFetch(url);
    throwIfFetchFailed(response);
  }

  /**
   * full path for the directory
   */
  async createDirectory(path: string): Promise<void> {
    console.log(`bb.createDirectory: path=${path}`);
    let c = this.bbConfig;
    let url = mkURL(
      `/api/bb/createdirectory`,
      "appKeyId",
      c.appKeyId,
      "appKey",
      c.appKey,
      "bucketId",
      c.bucketId,
      "path",
      path
    );
    let response = await apiFetch(url);
    throwIfFetchFailed(response);
  }

  async deleteFile(path: string): Promise<void> {
    path = s3SanitizePath(path);
    let c = this.bbConfig;
    let url = mkURL(
      `/api/bb/deletefile`,
      "appKeyId",
      c.appKeyId,
      "appKey",
      c.appKey,
      "bucketId",
      c.bucketId,
      "path",
      path
    );
    console.log(`bb.deleteFile: path: ${path}, uri: ${url}`);
    let rsp = await apiFetch(url);
    await throwIfFetchFailed(rsp);
  }
}

async function bbGetFiles(c: BackBlazeConfig, dir: string): Promise<any[][]> {
  dir = s3SanitizeDir(dir);
  let url = mkURL(
    `/api/bb/list`,
    "appKeyId",
    c.appKeyId,
    "appKey",
    c.appKey,
    "bucketId",
    c.bucketId,
    "dir",
    dir
  );
  console.log(`bb.getFiles: dir: '${dir}'`);
  let rsp = await apiFetch(url);
  await throwIfFetchFailed(rsp);
  return await rsp.json();
}

export function makeFileSystemBackBlaze(
  c: BackBlazeConfig
): FileSystemBackBlaze {
  let res = new FileSystemBackBlaze(c);
  return res;
}
